import { Term } from "@/components/Term";

const money = (v, d = 2) => (v == null ? "—" : `${Number(v) < 0 ? "-" : ""}$${Math.abs(Number(v)).toLocaleString(undefined, { maximumFractionDigits: d })}`);
const qty = (v) => Number(v).toLocaleString(undefined, { maximumFractionDigits: 8 });
const HEAD = ["Position", "Size", "Avg entry", "Live price", "Unrealised P&L", "Take-profit", "Stop-loss"];
const HEAD_KEY = { Position: "pt_product", Size: "pt_position_size", "Avg entry": "pt_avg_entry", "Live price": "pt_live_price", "Unrealised P&L": "pt_unrealised_pnl", "Take-profit": "pt_take_profit", "Stop-loss": "pt_stop_loss" };

const Exit = ({ e }) => {
  if (!e) return <span className="text-slate-600">none</span>;
  if (e.exit_role === "take_profit") return <span data-testid={`cb-pos-tp-${e.id}`}>{money(e.limit_price)}</span>;
  return (
    <span data-testid={`cb-pos-sl-${e.id}`}>
      {money(e.stop_price)}
      {e.trail_pct && <div className="text-[10px] text-amber-200/80 font-sans">trailing {e.trail_pct}% · high {money(e.high_water)}{e.ratchet_count ? ` · raised ×${e.ratchet_count}` : ""}</div>}
    </span>
  );
};

export const PositionsCard = ({ data }) => {
  const rows = data?.positions || [];
  return (
    <div className="apx-card p-4 space-y-2" data-testid="cb-positions">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="font-display font-semibold text-sm">Open paper positions <span className="text-xs text-slate-500 font-sans">({rows.length})</span></div>
        {data?.as_of && <span className="text-[10px] font-mono-ticker text-slate-500" data-testid="cb-positions-asof">priced {new Date(data.as_of).toLocaleTimeString()} · live market feed</span>}
      </div>
      <div className="tbl-scroll overflow-x-auto -mx-2 px-2">
        <table className="w-full text-xs">
          <thead><tr className="text-left text-[10px] uppercase tracking-wider text-slate-500 border-b border-slate-800">{HEAD.map((h) => <th key={h} className="py-1.5 pr-2 font-medium whitespace-nowrap"><Term k={HEAD_KEY[h]} side="bottom" iconClass="normal-case" testid={`cb-pos-th-${HEAD_KEY[h]}`}>{h}</Term></th>)}</tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={HEAD.length} className="py-3 text-slate-500" data-testid="cb-positions-empty">No open paper positions. Fill a BUY and its size, entry, live P&L and attached exits appear here.</td></tr>}
            {rows.map((p) => {
              const up = p.unrealised_pnl != null && Number(p.unrealised_pnl) >= 0;
              return (
                <tr key={p.product_id} className="border-b border-slate-800/60 font-mono-ticker" data-testid={`cb-pos-${p.base}`}>
                  <td className="py-1.5 pr-2">{p.product_id}</td>
                  <td className="py-1.5 pr-2">{qty(p.size)}{Number(p.reserved) > 0 && <div className="text-[10px] text-slate-500 font-sans">{qty(p.reserved)} reserved for exits</div>}</td>
                  <td className="py-1.5 pr-2">{money(p.avg_entry)}</td>
                  <td className="py-1.5 pr-2">{p.price_state === "live" ? money(p.market_price, 6) : <span className="text-rose-300">unavailable</span>}</td>
                  <td className={`py-1.5 pr-2 whitespace-nowrap ${p.unrealised_pnl == null ? "text-slate-500" : up ? "text-emerald-300" : "text-rose-300"}`} data-testid={`cb-pos-pnl-${p.base}`}>
                    {p.unrealised_pnl == null ? "—" : `${up ? "+" : ""}${money(p.unrealised_pnl)} (${up ? "+" : ""}${p.unrealised_pct}%)`}
                    {Number(p.realised_pnl) !== 0 && <div className="text-[10px] text-slate-500 font-sans">realised {money(p.realised_pnl)}</div>}
                  </td>
                  <td className="py-1.5 pr-2 whitespace-nowrap"><Exit e={p.exits.find((e) => e.exit_role === "take_profit")} /></td>
                  <td className="py-1.5 pr-2 whitespace-nowrap"><Exit e={p.exits.find((e) => e.exit_role === "stop_loss")} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {data?.note && <p className="text-[10px] text-slate-500">{data.note}</p>}
    </div>
  );
};
